<div *ngIf="quickSearch && !quickSearch.showInline" class="row py-3" role="button" (click)="showMore()">
  <div class="col-auto">
    <co-image key="searchsaved" type="svg" width="32" height="32" [imageSet]="imageSet"></co-image>
  </div>
  <a class="col align-middle text-uppercase">{{strings.Search }}...</a>
</div>